<template>
  <div class="shsq-container">
    <el-row class="tcf-row">
      <el-col  class="card">
        <div class="card-body">
          <el-form :inline="true" size="small" :model="searchForm" @submit.native.prevent>
            <el-form-item label="搜索关键字">
              <el-input v-model="searchForm.search" placeholder="关键字搜索" @keyup.enter.native="Search"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button icon="el-icon-search" @click="Search">搜索</el-button>
            </el-form-item>
            <el-form-item style="float: right">
              <el-button icon="el-icon-plus" type="primary" @click="editApply('0')">添加申请</el-button>
            </el-form-item>
          </el-form>
          <div class="card-content" >
            <el-row>
              <el-col :span="24" v-loading="loading">
                <el-table
                  :data="tableData"
                  stripe
                  :row-style="{cursor: 'pointer'}"
                  @row-click="openDetails"
                  style="width: 100%">
                  <el-table-column
                    label="订单号"
                    width="120"
                    fixed
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span>{{scope.row.order_num}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="经销商"
                    width="120"
                    align="center"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span :style="scope.row.all_name && scope.row.all_name.indexOf('VIP') > -1 ? 'font-weight: bold; color: #389e0d; font-style: italic;' : ''">
                        {{ scope.row.all_name }}
                      </span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="原正单号"
                    width="150"
                    align="center"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span>{{scope.row.product_num}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="详细地址"
                    min-width="200"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span>{{scope.row.address}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="申请时间"
                    width="170"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span>{{scope.row.time}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="状态"
                    width="120"
                    align="center"
                    fixed="right"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <el-tag :disable-transitions="true" size="mini" v-if="scope.row.mark===0" type="warning">待处理</el-tag>
                      <el-tag :disable-transitions="true" size="mini" v-if="scope.row.mark===1">已处理</el-tag>
                      <el-tag :disable-transitions="true" size="mini" v-if="scope.row.mark===2" type="danger">已驳回</el-tag>
                    </template>
                  </el-table-column>
                  <el-table-column
                    width="120"
                    fixed="right"
                    align="center"
                    label="操作">
                    <template slot-scope="scope">
                      <el-dropdown size="mini" v-if="scope.row.mark!==1" @click.stop="editApply(scope.row.after_id)" split-button icon="el-icon-edit">
                        <i class="el-icon-edit"></i> 编辑
                        <el-dropdown-menu slot="dropdown">
                          <el-dropdown-item @click.native="delApply(scope.row.after_id)" style="color:#F56C6C"><i class="el-icon-delete"></i> 删除申请</el-dropdown-item>
                        </el-dropdown-menu>
                      </el-dropdown>
                      <el-button v-if="scope.row.mark===1" size="mini" @click.stop="view(scope.row)" icon="el-icon-search">查看详情</el-button>
                    </template>
                  </el-table-column>
                </el-table>
                <el-pagination
                  v-if="total>0"
                  background
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :current-page="currentPage"
                  :page-sizes="[20, 50, 100]"
                  :page-size="pageSize"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="total">
                </el-pagination>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-dialog
      :title="editTitle"
      :visible.sync="editVisible"
      width="40%"
      top="10vh"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true">
      <el-form ref="editForm" v-loading="infoLoading" :model="editForm" :rules="editRules"  label-position="right" label-width="80px" size="small">
        <el-form-item label="订单选择" prop="orderid">
          <AfterOrderSelect :key="orderLoad" v-on:setOrder="setOrder" :oldorderid="oldorderid" v-model="editForm.orderid"></AfterOrderSelect>
        </el-form-item>
        <el-form-item label="生产单号" prop="productnum">
          <el-input v-model="editForm.productnum" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="生产车间" prop="factory">
          <el-input v-model="editForm.factory" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="经销商" prop="delname">
          <el-input v-model="editForm.delname" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="客诉时间" prop="time">
          <el-input v-model="editForm.time" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="终端地址" prop="address">
          <el-input v-model="editForm.address" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="售后/投诉内容" prop="content">
          <el-input v-model="editForm.content" type="textarea" maxlength="300" show-word-limit></el-input>
        </el-form-item>
        <el-form-item style="text-align: right;">
          <el-button type="primary" :loading="editloading" @click="subEdit('editForm')">立即提交</el-button>
          <el-button @click="editVisible=false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog
      title="售后处理详情"
      :visible.sync="infoVisible"
      width="40%"
      top="10vh"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true">
      <table class="tcf-detail-table" v-loading="fullscreenLoading">
        <tr>
          <th>订单号</th>
          <td>{{infoData.order.ordernum}}</td>
          <th>原正单号</th>
          <td>{{infoData.order.beforenum}}</td>
        </tr>
        <tr>
          <th>经销商</th>
          <td>{{infoData.order.all_name}}</td>
          <th>生产车间</th>
          <td>{{infoData.order.product_factory}}</td>
        </tr>
        <tr>
          <th>客诉时间</th>
          <td colspan="3">{{infoData.order.time}}</td>
        </tr>
        <tr>
          <th>终端地址</th>
          <td colspan="3">{{infoData.order.address}}</td>
        </tr>
        <tr>
          <th>投诉内容</th>
          <td colspan="3">{{infoData.afterSale.content}}</td>
        </tr>
        <tr>
          <th>返修单</th>
          <td colspan="3">
            <span @click="downFile(infoData.afterSale.reworkid)" class="tcf-link"><i class="el-icon-download"></i> {{infoData.afterSale.reworkname}}</span>
          </td>
        </tr>
        <tr>
          <th>判定单</th>
          <td colspan="3">
            <el-image
              style="width: 60px; height: 60px;"
              fit="cover"
              :preview-src-list="[infoData.afterSale.decision_url]"
              :src="infoData.afterSale.decision_url">
            </el-image>
          </td>
        </tr>
        <tr>
          <th>售后原因</th>
          <td colspan="3">{{infoData.reasonStr}}</td>
        </tr>
        <tr>
          <th>责任车间</th>
          <td>{{infoData.factory}}</td>
          <th>售后赔款</th>
          <td>{{infoData.afterSale.amount}}&nbsp;元</td>
        </tr>
        <tr>
          <th>售后备注</th>
          <td colspan="3">{{infoData.afterSale.remark}}</td>
        </tr>
        <tr>
          <th>处理人</th>
          <td>{{infoData.afterSale.username}}</td>
          <th>处理时间</th>
          <td>{{infoData.afterSale.opertime}}</td>
        </tr>
      </table>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="infoVisible = false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getUser } from '@/utils/auth'
import { getAfterSaleList, addOrEditAfterDetail, deleteAfterSale, afterSaleDetail, getAfterSalePageInfo } from '@/api/erp'
import AfterOrderSelect from '@/components/AfterOrderSelect'
import { getFileInfo } from '@/api/pub'

export default {
  name: 'shsq',
  computed: {
    user: getUser
  },
  components: {
    AfterOrderSelect
  },
  data() {
    return {
      searchForm: {
        search: ''
      },
      loading: false,
      tableData: [],
      currentPage: 1,
      pageSize: 20,
      total: 0,
      editTitle: '添加客户售后/投诉处理单',
      editVisible: false,
      infoLoading: false,
      editloading: false,
      orderLoad: '',
      oldorderid: '',
      editForm: {
        asid: null,
        orderid: '',
        productnum: '',
        factory: '',
        delname: '',
        time: '',
        address: '',
        content: ''
      },
      editRules: {
        orderid: [{ required: true, message: '请选择售后订单', trigger: 'change' }],
        content: [{ required: true, message: '请输入售后/投诉内容', trigger: 'blur' }]
      },
      infoVisible: false,
      fullscreenLoading: false,
      infoData: {
        rson: '',
        factory: '',
        order: {
          ordernum: null,
          beforenum: null,
          time: null,
          all_name: null,
          address: null,
          product_factory: null
        },
        afterSale: {
          decision_url: null,
          content: null,
          reworkname: null,
          reworkid: null,
          remark: null,
          amount: null,
          opertime: null,
          username: null
        }
      }
    }
  },
  created() {
    this.getData()
  },
  methods: {
    Search() {
      if (this.searchForm.search !== null && this.searchForm.search.trim() !== '') {
        this.currentPage = 1
        this.getData()
      } else {
        this.searchForm.search = ''
        this.getData()
      }
    },
    getData() {
      this.loading = true
      const data = {
        content: this.searchForm.search,
        page: this.currentPage,
        limit: this.pageSize,
        userid: this.user.dUserid,
        groupid: this.user.dGroupid,
        role: this.user.role
      }
      getAfterSaleList(data).then(response => {
        this.loading = false
        this.tableData = response.data
        this.total = response.total
      }).catch(() => {
        this.loading = false
      })
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getData()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getData()
    },
    openDetails(row) {
      this.$router.push({ path: '/work/order/' + row.order_id })
    },
    setOrder(data) {
      this.editForm.productnum = data.before_num
      this.editForm.factory = data.factory
      this.editForm.delname = data.all_name
      this.editForm.time = data.time
      this.editForm.address = data.address
    },
    editApply(id) {
      if (id === '0') {
        this.editTitle = '添加客户售后/投诉处理单'
        this.editForm.asid = null
        this.oldorderid = ''
        this.editForm.orderid = ''
        this.editForm.productnum = ''
        this.editForm.factory = ''
        this.editForm.delname = ''
        this.editForm.time = ''
        this.editForm.address = ''
        this.editForm.content = ''
        this.orderLoad = new Date().getTime()
      } else {
        this.editTitle = '编辑客户售后/投诉处理单'
        this.infoLoading = true
        afterSaleDetail({ afterid: id }).then(response => {
          this.editForm.asid = id
          this.editForm.orderid = response.data.order_id
          this.oldorderid = this.editForm.orderid
          this.orderLoad = new Date().getTime()
          this.editForm.productnum = response.data.product_num
          this.editForm.factory = response.data.product
          this.editForm.delname = response.data.all_name
          this.editForm.time = response.data.find_time
          this.editForm.address = response.data.address
          this.editForm.content = response.data.remark
          this.infoLoading = false
        }).catch(() => {
          this.infoLoading = false
        })
      }
      this.editVisible = true
    },
    subEdit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (!this.editloading) {
            this.editloading = true
            let applyid = 0
            if (this.editForm.asid !== null && this.editForm.asid !== '' && this.editForm.asid !== undefined) {
              applyid = this.editForm.asid
            }
            const data = {
              applyid: applyid,
              orderid: this.editForm.orderid,
              content: this.editForm.content
            }
            addOrEditAfterDetail(data).then(response => {
              this.$message({
                message: '客户售后/投诉处理单提交成功',
                type: 'success'
              })
              this.editVisible = false
              this.editloading = false
              this.getData()
            }).catch(() => {
              this.editloading = false
            })
          } else {
            return false
          }
        } else {
          return false
        }
      })
    },
    delApply(id) {
      this.$confirm('删除此客户售后/投诉处理单, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.fullscreenLoading = true
        deleteAfterSale({ userid: this.user.dUserid, afterid: id }).then(response => {
          this.fullscreenLoading = false
          this.$message({
            message: '删除成功',
            type: 'success'
          })
          this.getData()
        }).catch(() => {
          this.fullscreenLoading = false
        })
      }).catch(() => {})
    },
    view(row) {
      this.fullscreenLoading = true
      getAfterSalePageInfo({ afterid: row.after_id }).then(response => {
        this.infoData = response.data
        this.infoData.rson = this.infoData.afterSale.rsontype + ' / ' + this.infoData.afterSale.rson
        this.infoData.factory = this.infoData.afterSale.factory
        this.fullscreenLoading = false
      }).catch(() => {
        this.fullscreenLoading = false
      })
      this.infoVisible = true
    },
    downFile(fileid) {
      getFileInfo({ fileid: fileid }).then(response => {
        /* this.$message({
          message: '返修单已下载',
          type: 'success'
        })*/
        const a = document.createElement('a')
        // a.download = response.data.dName + '.' + response.data.dType
        a.href = response.data.copyPath
        a.target = '_blank'
        a.click()
        const h = this.$createElement
        this.$msgbox({
          title: '下载提示',
          message: h('div', { attrs: { style: 'letter-spacing:1px;padding-left: 15px;line-height: 22px;' }}, [
            h('span', null, `文件已下载，如文件未下载成功，请关闭相应浏览器拦截，`),
            h('a',
              { attrs: {
                href: response.data.copyPath,
                target: '_blank',
                download: `${response.data.dName}.${response.data.dType}`,
                style: 'color: #409EFF;text-decoration:underline;'
              }}, `点击这里`),
            h('span', null, `重新下载。`)
          ]),
          showCancelButton: false,
          confirmButtonText: '关闭',
          beforeClose: (action, instance, done) => {
            done()
          }
        }).then(action => {
        })
        /* let xhr = new XMLHttpRequest()
        const _this = this
        xhr.open('GET', response.data.viewurl, true)
        xhr.responseType = 'blob'
        xhr.onload = function() {
          if (this.status === 200) {
            let blob = this.response
            let a = document.createElement('a')
            a.download = response.data.dName + '.' + response.data.dType
            a.href = window.URL.createObjectURL(blob)
            a.click()
            const h = _this.$createElement
            _this.$msgbox({
              title: '下载提示',
              message: h('div', { attrs: { style: 'letter-spacing:1px;padding-left: 15px;line-height: 22px;' }}, [
                h('span', null, `文件已下载，如文件未下载成功，请关闭相应浏览器拦截，`),
                h('a',
                  { attrs: {
                    href: window.URL.createObjectURL(blob),
                    target: '_blank',
                    download: `${response.data.dName}.${response.data.dType}`,
                    style: 'color: #409EFF;text-decoration:underline;'
                  }}, `点击这里`),
                h('span', null, `重新下载。`)
              ]),
              showCancelButton: false,
              confirmButtonText: '关闭',
              beforeClose: (action, instance, done) => {
                done()
              }
            }).then(action => {
            })
          }
        }
        xhr.send()*/
      }).catch(() => {})
    }
  }
}
</script>

<style lang="scss" scoped>
.shsq-container {
  .tcf-row{
    .card{
      .card-body{
        .card-title{
          .add-btn{
            position: relative;
            float: right;
            margin-left: 10px;
            margin-top: -10px;
          }
          .search-mode{
            width: 300px;
            position: relative;
            float: right;
            margin-top: -10px;
            .search-input{
              background-color: #F2F6FC;
              border:0;
              height: 40px;
              line-height: 40px;
              border-radius: 4px;
              color: #606266;
              padding: 0 40px 0 15px;
              -webkit-appearance: none;
              font-size: 12px;
              width: 100%;
              -webkit-box-sizing: border-box;
              box-sizing: border-box;
              outline: 0;
              &::-webkit-input-placeholder {
                color: #C0C4CC;
              }
              &::-ms-input-placeholder {
                color: #C0C4CC;
              }
            }
            .search-btn{
              position: absolute;
              right: 0;
              height: 40px;
              width: 40px;
              line-height: 40px;
              top: 0;
              border: 0;
              background: transparent;
              text-align: center;
              padding: 0;
            }
          }
        }
        .card-content{
          .group-filter{
            width: 100%;
            padding: 0 30px 0 0 ;
            margin: 0 ;
            position: relative;
            li{
              width: 100%;
              list-style: none;
              position: relative;
              padding-left: 20px;
              padding-top: 15px;
              padding-bottom: 15px;
              cursor: pointer;
              border-radius: 2px;
              text-overflow: ellipsis;
              overflow: hidden;
              white-space: nowrap;
              &.active{
                background: #f5f7fa;
                color:#409EFF;
              }
              &:hover{
                color:#409EFF;
              }
            }
          }
          .el-table::before{
            height: 0!important;
          }
          .el-pagination{
            margin-top: 20px;
          }
        }
      }
    }
  }
}
</style>
